<template>
  <el-container>
    <el-header>
      <div style="margin: 20px 0">
        <el-button type="primary" size="small" @click="addWOA">添加公众号</el-button>
      </div>
    </el-header>
    <el-main>
      <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
        <span>删除后将无法恢复，确定删除？</span>
        <span slot="footer" class="dialog-footer">
                    <el-button @click="centerDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="isCzWeChat">确 定</el-button>
                  </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="csWeChatPlatformDiv"
        width="30%">
        <span>
          请使用您的微信号，向本公众号发送“测试公众号”五个字，若您收到反馈消息“公众号绑定成功”，则该公众号绑定成功。如未收到消息，请尝试重新编辑或授权您的公众号。
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="csWeChatPlatformDiv = false">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteWeChatPlatformDiv"
        width="30%">
        <span>
          删除成功，请登录微信公众平台 (https://mp.weixin.qq.com) 取消授权。<br/>
          具体操作：<br/>
          1) 点击微信公众平台左侧菜单栏中的 "添加功能插件"。<br/>
          2) 点击 "授权管理"。<br/>
          3) 点击 "三圆互联科技" 一项最右侧的 "查看平台详情" 链接<br/>
          4) 在页面下方, 点击 "取消授权"。<br/>
          5) 在弹出的提示框中点击 "确定"。<br/>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteWeChatPlatformDiv = false">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="输入微信开放平台第三方APPID" :visible.sync="appidInput">
        <el-form>
          <el-form-item label="APPID" :label-width="formLabelWidth">
            <el-input v-model="appid" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="appidInput = false">取 消</el-button>
          <el-button type="primary" @click="appidInputClick">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加公众号" :visible.sync="dialogFormVisible" width="100%" top="0vh" :before-close="handleClose">
        <el-button type="primary" @click="weChatBanding">B2B授权绑定</el-button>
        <el-button type="primary" @click="weChatBanding1">新零售授权绑定</el-button>
        <!--<el-button type="primary" @click="ptBanding">普通绑定</el-button>-->
        <el-divider></el-divider>
        <!--<el-alert
          title="你可能需要了解"
          type="success"
          :closable="false">
        </el-alert>
        <el-collapse>
          <el-collapse-item title="1.什么是订阅号" name="1">
            <div>订阅号生成的活动二维码为原始二维码，每次只能申请一场活动。（订阅号同时举行多场活动，扫码后会跳转到开始时间最近的一场活动，若用户想要参加其他的活动，就需要输入关键词：签到+活动编码）【未认证的服务号，也只能生成原始二维码】</div>
          </el-collapse-item>
          <el-collapse-item title="2.普通绑定需要注意什么？" name="2">
            <div>公众号使用“普通绑定”后，原本的菜单栏、消息回复会失效。而且操作比较麻烦，所以建议使用“微信授权绑定”即扫描绑定（扫描绑定不会占用和影响菜单栏、消息回复功能）</div>
          </el-collapse-item>
          <el-collapse-item title="3.普通绑定授权操作流程" name="3">
            <div>首先需要把页面第一步的URL与Token（令牌）信息，复制在微信公众平台里，点击【修改配置】按钮，进行复制粘贴，完成后点击【启用】按钮，就可以进行下一步；再把公众号对应的信息，填写到第二步页面的表单中。（信息就在公众号配置页面，其中开发者密码，即AppSecret，需要“重置”后，才能复制）</div>
          </el-collapse-item>
        </el-collapse>-->
      </el-dialog>
      <el-dialog title="消息模版详情" :visible.sync="dialogTableIndustry" width="100%" top="0vh">
        <table><tr><td>模&nbsp;&nbsp;版&nbsp;&nbsp;id：</td><td>{{gridData.template_id}}</td></tr><tr><td>一级行业：</td><td>{{gridData.primary_industry}}</td></tr><tr><td>二级行业：</td><td>{{gridData.deputy_industry}}</td></tr><tr><td>模板内容：</td><td>{{gridData.content}}</td></tr><tr><td>模板示例：</td><td>{{gridData.example}}</td></tr></table>
      </el-dialog>
      <el-dialog title="公众号详情" :visible.sync="weChatPlatformDesce" width="100%" top="0vh">
        <div class="addpublic topMarg">
          <div class="addpublic-top"><span>模版消息</span></div>
          <div class="table thisLeft basbj" style="position: relative;">
            <br/>
            <div style="text-indent: 10px;">主营行业：<span v-html="primary_industry"></span>&nbsp;&nbsp;副营行业：<span v-html="secondary_industry"></span>&nbsp;&nbsp;&nbsp;<el-button type="primary" size="small" v-show="isSetIndustry" @click="setIndustryFun">设置所属行业</el-button></div>
            <br/>
            <div style="text-indent: 10px;">消息模版：</div>
            <div>
              <el-tag type="success" v-for="(item,index) in industryList" :key="index" style="margin: 10px;cursor: pointer;" @click="openXq(item)">{{item.title}}</el-tag>
            </div>
            <br/>
          </div>
        </div>
        <br/>
        <div class="addpublic topMarg">
          <div class="addpublic-top"><span>授权域名</span></div>
          <div class="table thisLeft basbj" style="position: relative;text-indent: 10px;">
            <br/>
            <el-input placeholder="请输入域名，格式：http 或 https://xxxxxxxxx/" v-model="domainName" maxlength="80" show-word-limit style="width: 500px;margin-right: 20px;"></el-input><el-button type="primary" size="small" @click="setDomainName">设置域名</el-button>
            <br/><br/>
          </div>
        </div>
        <br/>
        <div class="addpublic topMarg">
          <div class="addpublic-top"><span>所属客户设置</span></div>
          <div class="table thisLeft basbj" style="position: relative;">
            <br/>
            <el-dropdown split-button type="primary" @command="commandUserEvent" style="margin-left: 10px;">
              <span v-html="dropdownTitle"></span>
              <el-dropdown-menu slot="dropdown" class="project-dropdown">
                <el-dropdown-item v-for="(item,index) in dropdownUserList" :key="index" :command="item.identification">{{item.customerName}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" size="small" @click="setIdentification">设置所属客户</el-button>
            <br/><br/>
          </div>
        </div>
        <br/>
        <div class="addpublic topMarg">
          <div class="addpublic-top"><span>基础信息</span></div>
          <div class="table thisLeft basbj" style="position: relative;">
            <table width="80%" border="0" cellspacing="0" cellpadding="0"><tbody>
            <tr><td class="texright">公众号类型：</td> <td v-html="retrunAuthorizer_info.service_type_info"></td> <td class="texright">公众号原始ID：</td> <td v-html="retrunAuthorizer_info.user_name"></td></tr>
            <tr><td class="texright">认证类型：</td> <td v-html="retrunAuthorizer_info.verify_type_info"></td> <td class="texright">主体名称：</td> <td v-html="retrunAuthorizer_info.principal_name"></td></tr>
            <tr><td class="texright">原始二维码：</td> <td v-html="retrunAuthorizer_info.qrcode_url"></td> <td class="texright">上次更新：</td> <td v-html="retrunAuthorizer_info.updateTime"></td></tr>
            <tr><td class="texright tdTop">业务开通信息：</td>
              <td class="tdTop">
                <ul>
                  <li>是否开通微信门店信息：<span v-html="retrunAuthorizer_info.business_info.open_store"></span></li>
                  <li>是否开通微信扫描商品：<span v-html="retrunAuthorizer_info.business_info.open_scan"></span></li>
                  <li>是否开通微信门支付：<span v-html="retrunAuthorizer_info.business_info.open_pay"></span></li>
                  <li>是否开通微信卡券：<span v-html="retrunAuthorizer_info.business_info.open_card"></span></li>
                  <li>是否开通微信摇一摇：<span v-html="retrunAuthorizer_info.business_info.open_shake"></span></li>
                </ul>
              </td>
              <td class="texright tdTop">二维码：</td>
              <td class="tdTop">
                <div class="qrCode"><img width="120px" :src="'http://img01.store.sogou.com/net/a/04/link?appid=100520029&url='+retrunAuthorizer_info.qrcode_url"> <p v-html="retrunAuthorizer_info.nick_name"></p></div>
              </td>
            </tr>
            </tbody>
            </table>
          </div>
        </div>
      </el-dialog>
      <template>
        <el-table
          :data="tableData"
          border
          :height="divHeight"
          style="width: 100%">
          <el-table-column
            fixed
            prop="authorizer_info.nick_name"
            label="公众号名称"
            width="220">
          </el-table-column>
          <el-table-column
            prop="authorizer_info"
            :formatter="returnWeChatType"
            label="公众号类型"
            width="110">
          </el-table-column>
          <el-table-column
            prop="authorizer_info"
            :formatter="returnWeChatRz"
            label="认证情况"
            width="180">
          </el-table-column>
          <el-table-column
            prop="createTime"
            :formatter="formatTime"
            label="创建时间"
            width="260">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="czWeChatPlatform(1,scope.row._id)">测试</el-button>
              <el-button type="text" size="small" @click="czWeChatPlatform(2,scope.row._id)">查看详情</el-button>
              <!--<el-button type="text" size="small" @click="czWeChatPlatform(3,scope.row._id)">重新授权</el-button>-->
              <el-button type="text" size="small" @click="czWeChatPlatform(4,scope.row._id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-main>
    <el-footer>
      <el-pagination
        background
        @size-change="handleSizeChange0"
        @current-change="handleCurrentChange0"
        :current-page="currentPage0"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="count0"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allcount0">
      </el-pagination>
    </el-footer>
  </el-container>
</template>
<script>
  export default {
    name: 'weChatOfficialAccount',
    data(){
      return {
        formLabelWidth: '120px',
        appid:'',
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        tableData:[],
        gridData:[],
        dropdownUserList:[],
        dropdownTitle:"请选择",
        domainName:"",
        appidInput:false,
        dialogTableIndustry:false,
        dialogFormVisible:false,
        dialogFormVisible1:false,
        centerDialogVisible:false,
        csWeChatPlatformDiv:false,
        deleteWeChatPlatformDiv:false,
        weChatPlatformDesce:false,
        active: 0,
        type:"",
        isId:"",
        sort1:true,
        sort2:false,
        sort3:false,
        radio: '服务号',
        name:"",
        weChatNumber:"",
        appId:'',
        appSecret:'',
        userId:'',
        URL:"console.hlhdpt.com",
        TOKEN:"hlhdpt",
        primary_industry:"",
        secondary_industry:"",
        isSetIndustry:true,
        industryList:[],
        retrunAuthorizer_info:{
          nick_name:"",
          authorizer_appid:"",
          service_type_info:"",
          verify_type_info:"",
          user_name:"",
          qrcode_url:"",
          principal_name:"",
          updateTime:"",
          business_info:{
            open_pay:"",
            open_shake:"",
            open_scan:"",
            open_card:"",
            open_store:""
          }
        }
      };
    },
    methods: {
      commandUserEvent(command) {
        this.dropdownTitle = command
      },
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      setIndustryFun(){
        this.type = 5;
        this.isCzWeChat();
      },
      setDomainName(){
        if(this.domainName == ""){
          this.$message({
            message: "请输入域名",
            type: 'warning'
          });
        }else{
          this.type = 6;
          this.isCzWeChat();
        }
      },
      setIdentification(){
        if(this.dropdownTitle == "" || this.dropdownTitle == "请选择"){
          this.$message({
            message: "请选择所属客户",
            type: 'warning'
          });
        }else{
          this.type = 7;
          this.isCzWeChat();
        }
      },
      returnWeChatType(row, column){
        var _t = row[column.property].service_type_info.id;
        switch(_t){
          case 0:
            return "订阅号";
            break;
          case 1:
            return "升级后的订阅号";
            break;
          case 2:
            return "服务号";
            break;
          default:
            return ""
        }
      },
      returnWeChatRz(row, column){
        var _t = row[column.property].verify_type_info.id;
        switch(_t){
          case -1:
            return "未认证";
            break;
          case 0:
            return "微信认证";
            break;
          case 1:
            return "新浪微博认证";
            break;
          case 2:
            return "腾讯微博认证";
            break;
          case 3:
            return "还未通过名称认证";
            break;
          case 4:
            return "还未通过名称认证，新浪微博认证";
            break;
          case 5:
            return "还未通过名称认证，腾讯微博认证";
            break;
          default:
            return ""
        }
      },
      handleSizeChange0(val) {
        this.count0 = val;
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
      },
      next() {
        if (this.active++ > 2) this.active = 0;
        if(this.active == 0){
          this.sort1 = true;
          this.sort2 = false;
          this.sort3 = false;
        }else if(this.active == 1){
          this.sort1 = false;
          this.sort2 = true;
          this.sort3 = false;
        }else if(this.active == 2){
          if(this.name == ""){
            this.$message({
              message: "请输入公众号名称",
              type: 'warning'
            });
          }else if(this.weChatNumber == ""){
            this.$message({
              message: "请输入微信号",
              type: 'warning'
            });
          }else if(this.userId == ""){
            this.$message({
              message: "请输入原始ID",
              type: 'warning'
            });
          }else if(this.appId == ""){
            this.$message({
              message: "请输入公众号AppID",
              type: 'warning'
            });
          }else if(this.appSecret == ""){
            this.$message({
              message: "请输入公众号AppSecretID",
              type: 'warning'
            });
          }else{
            this.$post('/root/saveWOA',{
              'name':this.name,
              'weChatNumber':this.weChatNumber,
              'appId':this.appId,
              'appSecret':this.appSecret,
              'userId':this.userId,
              'type':this.radio
            }).then((response,err) => {
              if(!err){
                if(response.code == "Login"){
                  this.$router.push({path:'/login'})
                }else if(response.code == "Fail"){
                  this.$message({
                    message: response.message,
                    type: 'warning'
                  });
                }else if(response.code == "Success"){
                  this.$message({
                    message: response.message,
                    type: 'success'
                  });
                  this.sort1 = false;
                  this.sort2 = false;
                  this.sort3 = true;
                }else{
                  this.$message({
                    message: response.message,
                    type: 'warning'
                  });
                }
              }
            });
          }
        }else{
          this.sort1 = true;
          this.sort2 = false;
          this.sort3 = false;
        }
      },
      step() {
        if (this.active-- <= 0) this.active = 0;
        if(this.active == 0){
          this.sort1 = true;
          this.sort2 = false;
          this.sort3 = false;
        }else if(this.active == 1){
          this.sort1 = false;
          this.sort2 = true;
          this.sort3 = false;
        }else if(this.active == 2){
          if(this.name == ""){
            this.$message({
              message: "请输入公众号名称",
              type: 'warning'
            });
          }else if(this.weChatNumber == ""){
            this.$message({
              message: "请输入微信号",
              type: 'warning'
            });
          }else if(this.userId == ""){
            this.$message({
              message: "请输入原始ID",
              type: 'warning'
            });
          }else if(this.appId == ""){
            this.$message({
              message: "请输入公众号AppID",
              type: 'warning'
            });
          }else if(this.appSecret == ""){
            this.$message({
              message: "请输入公众号AppSecretID",
              type: 'warning'
            });
          }else{
            this.sort1 = false;
            this.sort2 = false;
            this.sort3 = true;
          }
        }else{
          this.sort1 = true;
          this.sort2 = false;
          this.sort3 = false;
        }
      },
      addWOA(){
        this.dialogFormVisible = true;
      },
      UrlEncode(str){
        var output = '';
        var x = 0;
        var clearString = str.toString();
        var regex = /(^[a-zA-Z0-9-_.]*)/;
        while (x < clearString.length) {
          var match = regex.exec(clearString.substr(x));
          if (match != null && match.length > 1 && match[1] != '') {
            output += match[1];
            x += match[1].length;
          } else {
            if (clearString.substr(x, 1) == ' ') {
              //原文在此用 clearString[x] == ' ' 做判断, 但ie不支持把字符串当作数组来访问,
              //修改后两种浏览器都可兼容
              output += '+';
            }
            else {
              var charCode = clearString.charCodeAt(x);
              var hexVal = charCode.toString(16);
              output += '%' + ( hexVal.length < 2 ? '0' : '' ) + hexVal.toUpperCase();
            }
            x++;
          }
        }
        return output;
      },
      weChatBanding:async function(){
        await this.$axios.post('/root/weChatPlatformInfoAuthorization',{}).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            var _url = this.UrlEncode(response.data.url+"weChatPlatformAuthorization.html?component_appid=wx0163cecda40d185b");
            window.open(response.data.url+'weChatAuthorization.html?component_appid='+response.data.appId+'&pre_auth_code='+response.data.pre_auth_code+'&redirect_uri='+_url,'_black');
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      weChatBanding1(){
        this.appid = ''
        this.appidInput = true
      },
      appidInputClick:async function(){
        if (this.appid == '') {
          this.$message({
            message: '请输入appid',
            type: 'warning'
          });
        } else {
          await this.$axios.post('/root/weChatPlatformInfoAuthorization1',{
            appid: this.appid
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              var _url = this.UrlEncode(response.data.url+"weChatPlatformAuthorization.html?component_appid="+response.data.appId+"");
              window.open(response.data.url+'weChatAuthorization.html?component_appid='+response.data.appId+'&pre_auth_code='+response.data.pre_auth_code+'&redirect_uri='+_url,'_black');
            }else if(response.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });
        }
      },
      ptBanding(){
        this.dialogFormVisible = false;
        this.dialogFormVisible1 = true;
      },
      copyLink(val){
        var _this = this;
        if(val == 1){
          var clipboard = new _this.clipboard("#copyURL");
          clipboard.on('success', function(e) {
            _this.$message({
              message: "复制成功，去粘贴看看吧",
              type: 'success'
            });
          });
          //复制失败执行的回调
          clipboard.on('error', function(e) {
            _this.$message({
              message: "复制失败！请手动复制",
              type: 'warning'
            });
          });
        }
        if(val == 2){
          var clipboard1 = new _this.clipboard("#copyToken");
          clipboard1.on('success', function(e) {
            _this.$message({
              message: "复制成功，去粘贴看看吧",
              type: 'success'
            });
          });
          //复制失败执行的回调
          clipboard1.on('error', function(e) {
            _this.$message({
              message: "复制失败！请手动复制",
              type: 'warning'
            });
          });
        }
      },
      cs:async function(){
        await this.$axios.post('/root/getWeChatPlatform',{
          "count":this.count0,
          "page":this.currentPage0
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
        this.divHeight = window.innerHeight-158;
      },
      isCzWeChat:async function(){
        await this.$axios.post('/root/czWeChatPlatform',{
          "type":this.type,
          "_id":this.isId,
          "domainName":this.domainName,
          "identification":this.dropdownTitle
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            if(this.type == 4){
              this.cs();
              this.centerDialogVisible = false;
              this.deleteWeChatPlatformDiv = true;
            }else if(this.type == 2){
              this.retrunAuthorizer_info = response.data[0];
              var __industry = JSON.parse(response.data[1]);
              this.industryList = response.data[2];
              this.domainName = response.data[3];
              if(response.data[4]!=""){
                this.dropdownTitle = response.data[4];
              }else{
                this.dropdownTitle = "请选择";
              }
              if(__industry.errcode){
                this.isSetIndustry = true;
              }else {
                this.isSetIndustry = false;
                if(__industry.primary_industry){
                  this.primary_industry = (__industry.primary_industry.first_class?__industry.primary_industry.first_class:"")+"-"+(__industry.primary_industry.second_class?__industry.primary_industry.second_class:"")
                }
                if(__industry.secondary_industry){
                  this.secondary_industry = (__industry.secondary_industry.first_class?__industry.secondary_industry.first_class:"")+"-"+(__industry.secondary_industry.second_class?__industry.secondary_industry.second_class:"")
                }
              }
              this.weChatPlatformDesce = true;
            }else if(this.type == 5 ){
              this.$message({
                message: response.message,
                type: 'success'
              });
              this.weChatPlatformDesce = false;
              this.cs();
            }else if(this.type == 6){
              this.$message({
                message: response.message,
                type: 'success'
              });
              this.cs();
            }else if(this.type == 7){
              this.$message({
                message: response.message,
                type: 'success'
              });
              this.cs();
            }
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      handleClose(done){
        done();
        this.cs();
      },
      openXq(obj){
        this.gridData = obj;
        this.dialogTableIndustry = true;
        /*var html = '<table><tr><td>模版id</td><td>'+obj.template_id+'</td></tr><tr><td>一级行业</td><td>'+obj.primary_industry+'</td></tr><tr><td>二级行业</td><td>'+obj.deputy_industry+'</td></tr><tr><td>模板内容</td><td>'+obj.content+'</td></tr><tr><td>模板示例</td><td>'+obj.example+'</td></tr></table>';
        this.$alert(html, '消息模版详情', {
          dangerouslyUseHTMLString: true
        });*/
      },
      addUser:async function(){
        await this.$axios.post('/root/addUser',{
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownUserList = response.data;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      czWeChatPlatform(val,id){
        this.type = val;
        this.isId = id;
        if(val == 1){
          this.csWeChatPlatformDiv = true;
        }else if(val == 2){
          this.industryList = [];
          this.isSetIndustry = false;
          this.primary_industry = "";
          this.secondary_industry = "";
          this.domainName = "";
          this.isCzWeChat();
          this.addUser();
        }else if(val == 3){
          this.weChatBanding();
        }else if(val == 4){
          this.centerDialogVisible = true;
        }else{

        }
      }
    },
    mounted:function () {
      this.cs();
    }
  }
</script>
<style scoped>
  .acd {
    color: #0a8cd2!important;
    cursor: pointer;
  }
  .rightFlot {
    float: right;
    padding-right: 5px;
  }
  input, textarea, select {
    outline: none;
  }
  .capitalInput{
    width: 400px;
  }
  ul, li {
    margin: 0;
    padding: 0;
  }
  .input-text ul li {
    display: block;
    width: 100%;
    height: auto;
    margin-top: 10px;
  }
  ul li {
    list-style: none;
    margin-bottom: 20px;
  }
  ul li .name-head {
    width: 100px;
    height: 32px;
    text-align: right;
    line-height: 38px;
    font-size: 14px;
    color: #333;
    float: left;
  }
  .input-box {
    padding-left: 100px;
  }
  .addpublic {
    width: 100%;
    height: auto;
    border: 1px solid #dddddd;
    overflow: hidden;
    border-radius: 5px;
  }
  .addpublic-top {
    width: 100%;
    height: 42px;
    line-height: 42px;
    color: #000;
    font-size: 18px;
    border-bottom: 1px solid #dddddd;
    padding-left: 10px;
  }
  .table {
    padding: 0;
  }
  .basbj table {
    background-color: #fff;
  }
  .table table {
    background: #e8e8e8;
  }
  .thisLeft table tr td {
    padding: 10px 15px;
    text-align: left;
  }

  .table td {
    color: #666666;
    font-size: 14px;
    word-break: break-all;
    text-align: center;
    background: #fff;
    padding: 10px;
    transition: background 0.5s;
    -moz-transition: background 0.5s;
    -webkit-transition: background 0.5s;
    -o-transition: background 0.5s;
  }
  .texright {
    text-align: right!important;
  }
  .tdTop {
    vertical-align: top!important;
  }
  ul li {
    list-style: none;
  }
  ul, li {
    margin: 0;
    padding: 0;
  }
  .qrCode {
    width: 120px;
    text-align: center;
    border: 1px solid #dddddd;
  }
  .project-dropdown{
    height:300px !important;
    overflow: auto;
  }
  .project-dropdown::-webkit-scrollbar
  {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
  }
  .project-dropdown::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }
  .project-dropdown li{
    margin-bottom: 0px !important;
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/weChatOfficialAccount.vue